import { api } from "@/lib/api";

// Caché en memoria de peticiones ya lanzadas al pasar el ratón (prefetch).
const cache = new Map(); // url -> promesa axios

// Precarga los datos de una noticia y calienta el chunk de su ruta.
export function prefetchArticle(slug) {
  if (!slug) return;
  const key = `/articles/${slug}`;
  if (!cache.has(key)) {
    const p = api.get(key);
    p.catch(() => cache.delete(key)); // permite reintento si falla
    cache.set(key, p);
  }
  import("@/pages/HistoriaDetail").catch(() => {});
  return cache.get(key);
}

// Devuelve la promesa prefetcheada (si existe) para que la ficha abra al instante.
export function takeArticle(slug) {
  return cache.get(`/articles/${slug}`);
}

// --- Canciones ---
export function prefetchSong(slug) {
  if (!slug) return;
  const key = `/songs/${slug}`;
  if (!cache.has(key)) {
    const p = api.get(key);
    p.catch(() => cache.delete(key));
    cache.set(key, p);
  }
  import("@/pages/CancionDetail").catch(() => {});
  return cache.get(key);
}
export function takeSong(slug) {
  return cache.get(`/songs/${slug}`);
}

// --- Playlists ---
export function prefetchPlaylist(slug) {
  if (!slug) return;
  const key = `/playlists/${slug}`;
  if (!cache.has(key)) {
    const p = api.get(key);
    p.catch(() => cache.delete(key));
    cache.set(key, p);
  }
  import("@/pages/PlaylistDetail").catch(() => {});
  return cache.get(key);
}
export function takePlaylist(slug) {
  return cache.get(`/playlists/${slug}`);
}

// --- Radar (artista) --- solo calienta el chunk de la ruta.
export function prefetchArtist(slug) {
  if (!slug) return;
  import("@/pages/RadarArtist").catch(() => {});
}
